import axios from "axios";
import { Result } from "./types";

export interface ExportTransportProps {
  departure_facility?: string;
  arrival_facility?: string;
  transportShowByCategory?: boolean;
}

interface ExportResponse {
  url: string;
}

// Endpoint constants
const INBOUND_EXPORT_ALL = "/transport/inbound/export";
const INBOUND_EXPORT_ROUTE = "/transport/inbound/route/export";
const INBOUND_EXPORT_ERRORS_ALL = "/transport/inbound/errors/export";
const INBOUND_EXPORT_ERRORS_ROUTE = "/transport/inbound/route/errors/export";
const OUTBOUND_EXPORT_ALL = "/transport/outbound/export";
const OUTBOUND_EXPORT_ROUTE = "/transport/outbound/route/export";
const OUTBOUND_EXPORT_ERRORS_ALL = "/transport/outbound/errors/export";
const OUTBOUND_EXPORT_ERRORS_ROUTE = "/transport/outbound/route/errors/export";

// Existing export functions

export const exportInboundTransport = async ({
  departure_facility,
  arrival_facility,
}: ExportTransportProps): Promise<string> => {
  const { data } = await axios.get<Result>(
    `/export/inbound_transport?departure_facility=${departure_facility || ""}&arrival_facility=${
      arrival_facility || ""
    }`
  );
  return data.result.url;
};

export const exportOutboundTransport = async ({
  departure_facility,
  arrival_facility,
  transportShowByCategory,
}: ExportTransportProps): Promise<string> => {
  const { data } = await axios.get<Result>(`/export/outbound_transport`, {
    params: {
      departure_facility: departure_facility || "",
      arrival_facility: arrival_facility || "",
      by_transport_category: transportShowByCategory,
    },
  });
  return data.result.url;
};

// New export functions

export const exportAllInboundTransport = async ({ year }: { year?: number }): Promise<string> => {
  const yearParam = year ? { year } : {};
  const { data } = await axios.get<ExportResponse>(INBOUND_EXPORT_ALL, { params: yearParam });
  return data.url;
};

export const exportInboundTransportRoute = async (
  departure_facility_id: number,
  arrival_facility_id: number,
  transport_category: string,
  year?: number
): Promise<string> => {
  const { data } = await axios.get<ExportResponse>(INBOUND_EXPORT_ROUTE, {
    params: {
      departure_facility_id,
      arrival_facility_id,
      transport_category,
      ...(year ? { year } : {}),
    },
  });
  return data.url;
};

export const exportAllOutboundTransport = async ({ year }: { year?: number }): Promise<string> => {
  const yearParam = year ? { year } : {};
  const { data } = await axios.get<ExportResponse>(OUTBOUND_EXPORT_ALL, { params: yearParam });
  return data.url;
};

export const exportOutboundTransportRoute = async (
  departure_facility_id: number,
  arrival_name?: string,
  by_transport_category: boolean = false,
  year?: number
): Promise<string> => {
  const { data } = await axios.get<ExportResponse>(OUTBOUND_EXPORT_ROUTE, {
    params: {
      departure_facility_id,
      arrival_name,
      by_transport_category,
      ...(year ? { year } : {}),
    },
  });
  return data.url;
};

export const exportAllInboundTransportErrors = async ({
  year,
}: {
  year?: number;
}): Promise<string> => {
  const yearParam = year ? { year } : {};
  const { data } = await axios.get<ExportResponse>(INBOUND_EXPORT_ERRORS_ALL, {
    params: yearParam,
  });
  return data.url;
};

export const exportInboundTransportRouteErrors = async (
  departure_facility_id: number,
  arrival_facility_id: number,
  transport_category: string,
  year?: number
): Promise<string> => {
  const { data } = await axios.get<ExportResponse>(INBOUND_EXPORT_ERRORS_ROUTE, {
    params: {
      departure_facility_id,
      arrival_facility_id,
      transport_category,
      ...(year ? { year } : {}),
    },
  });
  return data.url;
};

export const exportAllOutboundTransportErrors = async ({
  year,
}: {
  year?: number;
}): Promise<string> => {
  const yearParam = year ? { year } : {};
  const { data } = await axios.get<ExportResponse>(OUTBOUND_EXPORT_ERRORS_ALL, {
    params: yearParam,
  });
  return data.url;
};

export const exportOutboundTransportRouteErrors = async (
  departure_facility_id: number,
  arrival_name?: string,
  by_transport_category: boolean = false,
  year?: number
): Promise<string> => {
  const { data } = await axios.get<ExportResponse>(OUTBOUND_EXPORT_ERRORS_ROUTE, {
    params: {
      departure_facility_id,
      arrival_name,
      by_transport_category,
      ...(year ? { year } : {}),
    },
  });
  return data.url;
};
